import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { useEffect, useState } from "react";
import TextInput from "src/Components/Authentication/TextInput";

const AddMaterialTypeModal = ({ categoryName = "Material", title, initialName = "", onCancel, onSave }) => {
  const [name, setName] = useState(initialName);

  useEffect(() => {
    setName(initialName);
  }, [initialName]);

  const handleSave = () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    onSave(trimmed);
    setName("");
  };

  const heading = title || `CREATE ${categoryName.toUpperCase()}`;

  return (
    <div className="fixed left-0 top-0 flex h-screen w-screen items-center justify-center bg-black bg-opacity-30 z-30">
      <OutsideClickHandler onOutsideClick={onCancel}>
        <div className="flex w-[360px] flex-col rounded-[6px] bg-white p-[18px] shadow-lg">
          <p className="mb-4 text-[16px] font-OpenSansMedium font-[600] text-titleColor">{heading}</p>
          <div className="flex flex-col gap-4">
            <TextInput
              label={`${categoryName} name`}
              placeholder={`Enter ${categoryName} name`}
              onTextChanged={setName}
              value={name}
              width="100%"
            />
            <div className="flex items-center justify-between gap-3">
              <button
                type="button"
                onClick={onCancel}
                className="flex h-[36px] w-[50%] items-center justify-center rounded-[6px] border border-subTitleColor text-[12px] font-OpenSansMedium text-subTitleColor"
              >
                CANCEL
              </button>
              <button
                type="button"
                onClick={handleSave}
                className="flex h-[36px] w-[50%] items-center justify-center rounded-[6px] bg-blueColor text-[12px] font-OpenSansMedium text-white"
              >
                SAVE
              </button>
            </div>
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default AddMaterialTypeModal;
